module.exports = __webpack_public_path__ + "img/sj-btn.f0e632c2.png";